<template>
	<el-dialog
		title="聊天历史记录"
		:visible.sync="visible"
		width="60vw"
		:before-close="onClose"
		class="chat-history-dialog"
		append-to-body
		:close-on-click-modal="false"
		:style="{ maxWidth: '100vw' }"
	>
		<div class="chat-history" v-loading="loading" element-loading-text="拼命加载中">
			<el-scrollbar class="scroll-box" ref="scrollbar" id="historyScrollbar">
				<ul>
					<li v-for="(msgInfo, idx) in messages" :key="idx">
						<chat-message-item :mode="2" :mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)"
							:showName="showName(msgInfo)" :msgInfo="msgInfo" :menu="false">
						</chat-message-item>
					</li>
				</ul>
			</el-scrollbar>
		</div>
	</el-dialog>
</template>

<script>
import ChatMessageItem from './ChatMessageItem.vue';

export default {
	name: 'chatHistory',
	components: {
		ChatMessageItem
	},
	props: {
		visible: {
			type: Boolean
		},
		chat: {
			type: Object
		},
		friend: {
			type: Object
		},
		group: {
			type: Object
		},
		groupMembers: {
			type: Array,
		}
	},
	data() {
		return {
			page: 1,
			size: 10,
			messages: [],
			loadAll: false,
			loading: false,
			lastScrollTime: new Date()
		}
	},
	methods: {
		onClose() {
			this.page = 1;
			this.messages = [];
			this.loadAll = false;
			this.$emit('close');
		},
		onScroll() {
			let high = this.$refs.scrollbar.$refs.wrap.scrollTop; //距离顶部的距离
			let timeDiff = new Date().getTime() - this.lastScrollTime.getTime();
			if (high < 30 && timeDiff > 500) {
				this.lastScrollTime = new Date();
				this.loadMessages();

			}
		},
		loadMessages() {
			if (this.loadAll) {
				return this.$message.success("已到达顶部");
			}
			let param = {
				page: this.page++,
				size: this.size
			}
			if (this.chat.type == 'GROUP') {
				param.groupId = this.group.id;
			} else {
				param.friendId = this.friend.id;
			}
			this.loading = true;
			this.$http({
				url: this.histroyAction,
				method: 'get',
				params: param
			}).then(messages => {
				messages.forEach(m => this.messages.unshift(m));
				this.loading = false;
				if (messages.length < this.size) {
					this.loadAll = true;
				}
				this.refreshScrollPos();
			}).catch(() => {
				this.loading = false;
			})
		},
		showName(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		refreshScrollPos() {
			let scrollWrap = this.$refs.scrollbar.$refs.wrap;
			let scrollHeight = scrollWrap.scrollHeight;
			let scrollTop = scrollWrap.scrollTop;
			this.$nextTick(() => {
				let offsetTop = scrollWrap.scrollHeight - scrollHeight;
				scrollWrap.scrollTop = scrollTop + offsetTop;
				// 滚动条没出来，继续加载
				if (scrollWrap.scrollHeight == scrollHeight) {
					this.loadMessages();
				}
			});
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		histroyAction() {
			return `/message/${this.chat.type.toLowerCase()}/history`;
		}
	},
	watch: {
		visible: {
			handler(newValue, oldValue) {
				if (newValue) {
					this.loadMessages();
					this.$nextTick(() => {
						document.getElementById('historyScrollbar').addEventListener("mousewheel", this.onScroll, true);
					});
				}
			}
		}
	}
}
</script>

<style lang="scss">
.chat-history-dialog {
	::v-deep .el-dialog__body {
		padding: 0;
		overflow-x: hidden !important;
	}
	::v-deep .el-dialog {
		overflow-x: hidden !important;
		margin: auto !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
		position: absolute !important;
		border-radius: 4px !important;
	}
}

// 强制所有相关层级都无横向滚动条
::v-deep .el-scrollbar,
::v-deep .el-scrollbar__wrap,
::v-deep .el-scrollbar__view,
::v-deep .el-dialog,
::v-deep .el-dialog__body,
.chat-history,
.scroll-box,
ul,
li {
	overflow-x: hidden !important;
	max-width: 100% !important;
}
::v-deep .el-scrollbar__bar.is-horizontal {
	display: none !important;
}

// 聊天消息内容强制自动换行和缩放
::v-deep .chat-message-item,
::v-deep .chat-message-item * {
	word-break: break-all !important;
	white-space: normal !important;
	max-width: 100% !important;
}
// 图片、卡片等内容自适应缩放
::v-deep img,
::v-deep .card,
::v-deep .message-content {
	max-width: 100% !important;
	height: auto;
	display: block;
}

.chat-history {
	display: flex;
	height: 500px;
	max-height: 60vh;
	box-sizing: border-box;
	width: 100%;
	
	.scroll-box {
		flex: 1;
		.el-scrollbar__thumb {
			background-color: #555555;
		}
		ul {
			padding: 20px;
			margin: 0;
			li {
				list-style-type: none;
			}
		}
	}
  // 覆盖 loading 图标颜色
  ::v-deep .el-loading-spinner i {
    color: #027aff !important;
  }
  // 覆盖 loading 文字颜色
  ::v-deep .el-loading-spinner .el-loading-text {
    color: #027aff !important;
  }
}
::v-deep .el-dialog__headerbtn:hover .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close svg,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close path {
  color: #027aff !important;
  fill: #027aff !important;
}
</style>
